<template>
    <div>
        <router-view />
        <toast></toast>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Toast from '@/components/layout/Toast.vue';

export default {
    name: 'app',
    components: {
        Toast,
    },
    computed: {
        ...mapGetters([
            "stateApkVersion",
        ]),
    },
    methods: { }
}
</script>

<style>
body {
    /* background-color: #f1f2f7 !important; */
}
</style>